<template>
  <div class="component-small-class">
    <h1 class="h1 color-gray-1">Capstone Prerequisites</h1>
    <PrerequisitesContent :isPaid="isPaid" />
  </div>
</template>

<script>
import Mixin from '../mixin.vue';
import PrerequisitesContent from './Content';

/**
 * @module CapstonePrerequisites
 * @desc Capstone Prerequisites课程内页
 */
export default {
  name: 'CapstonePrerequisites',
  mixins: [Mixin],
  components: {
    PrerequisitesContent
  },
  mounted() {
    document.title = 'Capstone Prerequisites';
  }
};
</script>
